import { render, staticRenderFns } from "./CompetenceTable.vue?vue&type=template&id=76f1376a&scoped=true"
import script from "./CompetenceTable.vue?vue&type=script&lang=js"
export * from "./CompetenceTable.vue?vue&type=script&lang=js"
import style0 from "@/utils/rich_text_editor.css?vue&type=style&index=0&id=76f1376a&prod&scoped=true&lang=css&external"
import style1 from "./CompetenceTable.vue?vue&type=style&index=1&id=76f1376a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f1376a",
  null
  
)

export default component.exports